import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { CruiseLineHotLinksLogos, TreatYourselfLogos } from 'src/common-types/index';
import { CruiseLineHotLinks, TreatYourself } from 'src/components/components/index';
import { IMenuState } from 'src/store/slices/index';
import { RootState } from 'src/store';
import CruisesBackground from 'src/assets/images/cruises/bg-cruises.jpg';
import { CruisesProgramList } from '../cruises-prorgams-list';
import { MasterClasses } from '../../../home/master-classes';
import './style.scss';

interface IMapStateToProps {
  menuStore: IMenuState;
}

interface IProps extends IMapStateToProps {}

export class CruisesWrapperComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { menuStore } = this.props;
    const phone = menuStore.items?.phone;

    return (
      <div className="cruises-wrapper">
        <div
          className="cruises-wrapper__header"
          style={{ backgroundImage: `url(${CruisesBackground})` }}
        >
          <div className="cruises-wrapper__wrapper">
            <div className="cruises-wrapper__container">
              <h1 className="cruises-wrapper__header_title">
                <FormattedMessage id="members.love.cruising" />
              </h1>
              <p className="cruises-wrapper__header_subtitle">
                <FormattedMessage id="cruising.is.the.worlds.favorite" />
              </p>
            </div>
          </div>
        </div>
        <div className="cruises-wrapper__wrapper">
          <CruisesProgramList />
        </div>
        <div className="cruises-wrapper__background">
          <div className="cruises-wrapper__wrapper">
            <p className="cruises-wrapper__title">
              <FormattedMessage id="we.promise.to.exceed.your.expectations" />
            </p>
            <p className="cruises-wrapper__subtitle">
              <FormattedMessage id="our.team.of.based.travel.professionals" />
            </p>
          </div>
        </div>
        <TreatYourself customerServiceNumber={phone} logos={TreatYourselfLogos} />
        <MasterClasses />
        <CruiseLineHotLinks logos={CruiseLineHotLinksLogos} />
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
  };
};

export const CruisesWrapper = connect(mapStateToProps, null)(CruisesWrapperComponent);
